
import React from 'react'

import './NotifInfo.css'

const NotifInfo = ({ title, message }) => {

    return (
        <div className="notif-info">
            <div className="title">{title}</div>
            <div className="message" dangerouslySetInnerHTML={{ __html: message }} />
        </div>
    )
}

export default NotifInfo
